import React, { useEffect, useState } from 'react'
import { LooksTwo } from '@mui/icons-material'
import InfoIcon from '@mui/icons-material/Info'
import { Stack, Tooltip, Typography } from '@mui/material'
import Flipcard from 'common/Card/Flipcard'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

export interface EsimStatusCardPropsV2 {
  esimStatus: string
  tooltipInfo: string
  esimTextColor: string
  whitelist: string
}
export default function EsimStatusCardV2({
  esimStatus,
  tooltipInfo,
  esimTextColor,
  whitelist
}: EsimStatusCardPropsV2) {
  const [warning, setWarning] = useState(false)

  useEffect(() => {
    if (esimStatus === 'RELEASED') {
      setWarning(true)
    } else {
      setWarning(false)
    }
  }, [esimStatus])

  return (
    <>
      <Flipcard
        warning={warning}
        icon={<LooksTwo sx={{ fontSize: '40px', color: 'white' }} />}
        backContent={
          <>
            <NormalText mt='2rem'>
              Please get customer to install eSim and turn on data roaming
            </NormalText>
          </>
        }
      >
        <NormalText
          isBold
          textAlign={'left'}
          sx={{
            fontSize: '24px',
            fontWeight: '700px',
            m: 0
          }}
          text={'eSim Status'}
        />
        <TextColorFontBody
          sx={{
            fontSize: '14px',
            lineHeight: 1,
            color: '#7B8794',
            textAlign: 'left',
            mt: 1
          }}
        >
          The current state of the customer&apos;s eSim. Please ensure
          customer&apos;s eSIM is enabled if they&apos;re travelling
        </TextColorFontBody>
        <Stack sx={{ mt: 3 }}>
          <Typography
            sx={{ fontWeight: '400', color: '#7B8794' }}
            textAlign='left'
          >
            Status
          </Typography>
          <Stack flexDirection={'row'} spacing={1}>
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: '33px',
                pt: '15px',
                color: esimTextColor
              }}
            >
              {esimStatus}
            </Typography>
            { esimStatus ?
            <Tooltip
              PopperProps={{
                sx: { maxWidth: '165px', textAlign: 'center' }
              }}
              title={tooltipInfo}
            >
              <InfoIcon fontSize='small' color='disabled' />
            </Tooltip> : null
            }
          </Stack>
          <Typography
            sx={{ fontWeight: '400', color: '#7B8794' }}
            textAlign='left'
          >
            {whitelist}
          </Typography>
        </Stack>
      </Flipcard>
    </>
  )
}
